import apiClient from '../client'
import type {
  SalesHistorySupplierMatch,
  SupplierSalesHistoryResponse,
} from '../models/response/salesHistory'

const BASE_PATH = '/closeout/sales-history'

// Historial de Ventas — Vista 360° del Proveedor (Menú 1.6.3).
export const salesHistoryService = {
  // Buscador indexado de proveedores con ventas realizadas (RUC / DNI / razón social).
  async searchSuppliers(q?: string): Promise<SalesHistorySupplierMatch[]> {
    return apiClient.get<SalesHistorySupplierMatch[]>(`${BASE_PATH}/suppliers`, {
      q: q || undefined,
    })
  },

  // Vista 360° de un proveedor (KPIs + semáforo de cumplimiento + grilla de lotes).
  async getSupplierHistory(supplierId: string): Promise<SupplierSalesHistoryResponse> {
    return apiClient.get<SupplierSalesHistoryResponse>(BASE_PATH, { supplierId })
  },
}
